import { Fragment } from "react"
import { css, cx } from "@emotion/css"

import { fetchClients } from "api/clients"
import { IOption } from "components/types"
import { fetchRateCardClients } from "api/ratecard"

const styles = {
  paper: css`
    min-width: 360px;
  `,
  short: css`
    min-width: 3.5rem;
  `,
  label: css`
    margin-left: 0.1rem;
  `,
}

interface ClientOption extends IOption {
  code?: string
}

export const fetchClientsOptionsQueryKey = "clients-input"
export function fetchClientsOptions(
  key: string,
  inputValue: string,
): Promise<ClientOption[]> {
  const ps = new URLSearchParams({ limit: "20", status: "ACTIVE" })
  if (inputValue) {
    ps.set("name", inputValue.trim())
  }
  return fetchClients(key, ps.toString()).then((res) => {
    return res.data.map((x) => ({
      label: x.name,
      value: x.id,
      code: x.code,
    }))
  })
}

export const fetchRateCardClientsOptionsQueryKey = "ratecard-clients-input"
export function fetchRateCardClientsOptions(
  key: string,
  inputValue: string,
  param?: { key: string; value: string },
): Promise<ClientOption[]> {
  const ps = new URLSearchParams()
  if (inputValue) {
    ps.set("name", inputValue.trim())
  }
  if (!!param) {
    ps.set(param.key, param?.value)
  }
  return fetchRateCardClients(key, ps.toString()).then((res) => {
    return res
      ?.filter((option) => Object.keys(option)?.length)
      .map((x) => ({
        label: x.name,
        value: x.id,
        code: x.code,
      }))
  })
}

export const renderClientOption = (option: ClientOption) => (
  <Fragment>
    <span className={cx("BodyBody-2BlackRegular", styles.short)}>
      {option.code}
    </span>
    <span className={cx("BodyBody-2Dark-greyRegular", styles.label)}>
      {option.label}
    </span>
  </Fragment>
)
